import React from 'react';
// import VideoCall from '../components/videoCall/VideoCall';
import { withRouter } from 'react-router';
function videoCall() {
	return <div>{/* <VideoCall /> */}</div>;
}

export default withRouter(videoCall);
